/* eslint-disable camelcase */

import React from 'react';
import hash from 'string-hash';
import isEqual from 'lodash.isequal';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import styled from 'styled-components';

const EmbedWrapper = styled.div`
    &.html-video-embed {
        height: 100%;
        width: 100%;
    }
`;

export default class HtmlVideoEmbed extends React.Component {
    static propTypes = {
        contentId: PropTypes.string,
        content: PropTypes.array,
        play: PropTypes.bool,
        forcePause: PropTypes.bool,
        height: PropTypes.number,
        width: PropTypes.number,
        onClick: PropTypes.func,
        playsInline: PropTypes.bool,
        mute: PropTypes.bool,
        controls: PropTypes.bool
    };

    hashId = '';
    state = {
        content: []
    };

    UNSAFE_componentWillMount() {
        this.setHash();
        this.checkState(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.play !== nextProps.play ||
                this.props.forcePause !== nextProps.forcePause ||
                (!nextProps.forcePause && nextProps.play)
        ) {
            //need to play/pause
            if (this.hashId) {
                const media = root.document.getElementById(`bgVideoHtml5-${this.hashId}`);
                if (media) {
                    if (nextProps.forcePause) {
                        media.pause();
                        media.currentTime = 0;
                        this.setState({
                            hidePlayPause: false
                        });
                    } else if (nextProps.play && media.paused) {
                        try {
                            const play = media.play();
                            if (play && play.then) {
                                play.then(
                                    () => {
                                        //console.debug('play success');
                                    },
                                    ex => {
                                        console.warn(
                                            'HtmlVideoEmbed play promise failed: %s',
                                            ex.message
                                        );
                                    }
                                );
                            }
                        } catch (e) {
                            console.warn('HtmlVideoEmbed play() failed');
                        }
                    } else if (!nextProps.play && !media.paused) {
                        try {
                            const pause = media.pause();
                            if (pause && pause.then) {
                                pause.then(
                                    () => {
                                        //console.debug('pause success');
                                    },
                                    () => {
                                        console.warn('HtmlVideoEmbed pause promise failed');
                                    }
                                );
                            }
                        } catch (e) {
                            console.warn('HtmlVideoEmbed pause() failed');
                        }
                    }
                }
            }
        }

        if (nextProps.height !== this.props.height || nextProps.width !== this.props.width) {
            if (this.hashId) {
                const media = root.document.getElementById(`bgVideoHtml5-${this.hashId}`);
                if (media) {
                    media.setAttribute('width', nextProps.width);
                    media.setAttribute('height', nextProps.height);
                }
            }
        }

        this.checkState(nextProps);
    }

    /**
     * Purposely avoid rerendering when height, width, and play props change
     */
    shouldComponentUpdate(nextProps, nextState) {
        if (!isEqual(nextState, this.state)) {
            return true;
        }
        const p = this.props;
        if (
            nextProps.contentId !== p.contentId ||
            nextProps.forcePause !== p.forcePause ||
            nextProps.mute !== p.mute
        ) {
            return true;
        } else if (!isEqual(nextProps.content, this.state.content)) {
            return true;
        }
        return false;
    }

    checkState = props => {
        const {content} = props;
        if (content) {
            if (!isEqual(content, this.state.content)) {
                this.setState({
                    content
                });
            }
        }
    };

    setHash = () => {
        if (!this.hashId && this.props) {
            if (this.props.contentId) {
                this.hashId = this.props.contentId;
            } else if (this.props.content && this.props.content[0]) {
                const string = this.props.content[0] || '';
                this.hashId = hash(string);
            } else {
                console.warn('HtmlVideoEmbed content id and content array is empty');
            }
        }
    };

    onClickHtmlVideo = event => {
        event.preventDefault();
        const media = root.document.getElementById(`bgVideoHtml5-${this.hashId}`);
        this.html5PlayPause(media);
    };

    html5PlayPause = media => {
        if (media) {
            if (media.paused) {
                media.play();
            } else {
                media.pause();
                media.currentTime = 0;
            }
            this.setState({
                hidePlayPause: !media.paused
            });
        }
    };

    render() {
        const sources = [];
        let sourceKey = 0;
        for (const reference of this.props.content) {
            const key = `source-key-${sourceKey++}`;
            sources.push(<source key={key} src={reference} />);
        }

        return (
            <EmbedWrapper className="html-video-embed">
                <video
                    loop
                    preload={this.props.play ? 'auto' : 'metadata'}
                    muted={this.props.mute}
                    playsInline={this.props.playsInline}
                    autoPlay={this.props.play}
                    id={`bgVideoHtml5-${this.hashId}`}
                    className="bg-video-html5 html-video"
                    ref={this.hashId}
                    data-contentid={this.hashId}
                    controls={this.props.controls || false}
                    onClick={this.props.onClick || this.onClickHtmlVideo}>
                    {sources}
                    Your browser does not support HTML5 video.
                </video>
            </EmbedWrapper>
        );
    }
}
